(function() {
  const popup = document.getElementById('mgo-quiz-popup');
  if (!popup) return;

  const overlay = popup.querySelector('.mgo-quiz-popup__overlay');
  const closeBtn = popup.querySelector('#mgo-quiz-close');
  const body = document.body;

  function openPopup() {
    popup.classList.add('show');
    body.classList.add('mgo-quiz-popup-open');
  }

  function closePopup() {
    popup.classList.remove('show');
    body.classList.remove('mgo-quiz-popup-open');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('show')) {
      closePopup();
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target && e.target.matches('[data-mgo-quiz-trigger]')) {
      e.preventDefault();
      openPopup();
    }
  });

  window.MGOQuizPopup = {
    open: openPopup,
    close: closePopup
  };
})();
